import { AddProduct, ECommerce, ProductForm } from "../../../../constants";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";
import Sidebar from "./Sidebar";
import ProductTabs from "./productTabs";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";

// This component handles the add product page, including the sidebar and form components.
const AddProductContainer = () => {

  return (
    <>
      <Breadcrumbs mainTitle={AddProduct} parent={ECommerce} />
      <Container fluid>
        <Row>
          <Col xs="12">
            <Card className="custom-product-form">
              <CommonCardHeader title={ProductForm} headClass="pb-0"/>
              <CardBody> 
                <Row className="g-xl-5 g-3 gy-4"> 
                  <Sidebar />
                  <ProductTabs /> 
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddProductContainer;